'use strict';

module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};




//////////////////
// WEBPACK FOOTER
// ./~/is-negative-zero/index.js
// module id = 526
// module chunks = 35783957827783 76758144387212 112643250470497